export default "__VITE_ASSET__7qkTHAUY__"